import { Flex, Text, Title } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import src from '@/assets/images/document.png';

import s from './EmptyNews.module.scss';

type EmptyNewsProps = {
  className?: string;
};

const EmptyNews: React.FC<EmptyNewsProps> = ({ className }) => {
  return (
    <div className={cn(s.root, className)}>
      <Flex className={s.root__content} align="center" direction="column" gap="xs">
        <Flex align="center" direction="column" gap="sm">
          <img src={src} width={130} height={130} className={s.root__image} />
          <Title size="h2">Выберите новость</Title>
        </Flex>
        <Text size="md" c="dimmed">
          Выберите новость слева для просмотра
        </Text>
      </Flex>
    </div>
  );
};

export default React.memo(EmptyNews);
